import React, { Component } from 'react'
import { nameRegex, amountRegex, nameAndNumberRegex } from 'Constants/regularExpression'
import { GET_URL } from 'Includes/urls'
import { minDate } from 'Constants';


const Form_Details = [{
    page_details: {
        form_name: 'company_form',
        form_label: 'Company Form',
        request_type: 'web',
        sub_sections: {
            company_details: {
                name: 'company_details',
                label: 'Company Details',
                can_hide: false,
                hidden: false,
                list: [
                    {
                        label: 'Company Name', regex: nameRegex, name: 'name', md: 6, className: 'w-95-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Company Code', regex: nameAndNumberRegex, name: 'code', md: 6, className: 'w-95-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Owner Name', regex: nameRegex, name: 'ownername', md: 4, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 100
                    },
                    {
                        label: 'Owner Number', regex: null, name: 'phonenumber', md: 4, className: 'w-90-per', required: false, id: 'outlined-textarea',
                        default: '+91', rows: null, type: 'phone_number'
                    },
                    {
                        label: 'Owner Email', regex: null, name: 'owneremail', md: 4, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 100
                    },
                    {
                        label: 'School Type', regex: nameRegex, name: 'type', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Institute Type', regex: null, name: 'institute_type', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: ['school'], rows: null, type: 'dropDown', multiple: true,
                        list: [
                            { id: 'school', name: 'School' },
                            { id: 'nursing', name: 'Nursing' },
                            { id: 'college', name: 'College' },
                            { id: 'engineering', name: 'Engineering' },
                        ]
                    },
                    {
                        label: 'Board Name', regex: nameRegex, name: 'board_name', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Fax Number', regex: nameRegex, name: 'fax_num', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'GSTIN Number', regex: nameRegex, name: 'gstin_num', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },

                    {
                        label: 'Database key', regex: nameAndNumberRegex, name: 'database_key', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Database Name', regex: nameAndNumberRegex, name: 'database_name', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Domain', regex: null, name: 'domain', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Optional Domain Name', regex: null, name: 'optional_domain_name', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 255
                    },
                    {
                        label: 'Enquiry Format', regex: '', name: 'enquiry_format', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },

                    {
                        label: 'Application Format', regex: '', name: 'application_format', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Admission Format', regex: '', name: 'admission_format', md: 3, className: 'w-90-per', required: true,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Active', regex: nameRegex, name: 'active', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: true, rows: null, type: 'switch', maxLength: 50
                    },
                    {
                        label: 'Create Company URL', regex: nameRegex, name: 'create_company_url', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: false, rows: null, type: 'switch', maxLength: 50
                    },
                    {
                        label: 'Payment Gateway Enabled', regex: nameRegex, name: 'payment_gateway_enabled', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: false, rows: null, type: 'switch', maxLength: 50
                    },
                    {
                        label: 'Biometric', regex: nameRegex, name: 'biometric', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: false, rows: null, type: 'switch', maxLength: 50
                    },
                    {
                        label: 'Website', regex: nameRegex, name: 'website', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: false, rows: null, type: 'switch', maxLength: 50
                    },
                ]
            },
            active_details: {
                name: 'active_details',
                label: 'Active Details',
                can_hide: false,
                hidden: false,
                list: [
                    {
                        label: 'From Date', regex: null, name: 'from_date', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'date', maxLength: null, minDate: minDate, maxDate: new Date(),

                    },
                    {
                        label: 'To Date', regex: null, name: 'to_date', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'date', maxLength: null, parentMinDate: 'from_date',
                        maxDate: new Date(),
                    },
                    {
                        label: 'Total Amount', regex: amountRegex, name: 'total_aount', md: 3, className: 'w-90-per', required: false, id: 'outlined-textarea',
                        default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    },
                    {
                        label: 'Paid Amount', regex: amountRegex, name: 'paid_aount', md: 3, className: 'w-90-per', required: false, id: 'outlined-textarea',
                        default: '', rows: null, type: 'number', maxNumber: 99999999, minNumber: 0
                    },
                ],
            },
            contact_details: {
                name: 'contact_details',
                label: 'Contact Details',
                can_hide: false,
                hidden: false,
                list: [
                    {
                        label: 'Primary Contact', regex: nameRegex, name: 'contact_person1', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Mobile Num', regex: null, name: 'tel_num', md: 3, className: 'w-90-per', required: false, id: 'outlined-textarea',
                        default: '+91', rows: null, type: 'phone_number'
                    },
                    {
                        label: 'Employee Contact', regex: nameRegex, name: 'contact_person2', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Alt Mobile Num', regex: null, name: 'tel_num_2', md: 3, className: 'w-90-per', required: false, id: 'outlined-textarea',
                        default: '+91', rows: null, type: 'phone_number'
                    },

                    {
                        label: 'Country', regex: nameRegex, name: 'country', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'State', regex: nameRegex, name: 'state', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'District', regex: nameRegex, name: 'district', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'City', regex: nameRegex, name: 'city', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 50
                    },
                    {
                        label: 'Address', regex: nameRegex, name: 'address', md: 6, className: 'w-95-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 150
                    },
                    {
                        label: 'Pincode', regex: nameRegex, name: 'pincode', md: 3, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: '', rows: null, type: 'text', maxLength: 6
                    },
                ]
            },
            billing_details: {
                name: 'billing_details',
                label: 'Billing and Contact Details',
                can_hide: false,
                hidden: false,
                list: [
                    {
                        label: 'Billing Address', regex: null, name: 'secondary_billing_address', md: 6, className: 'w-95-per', required: false,
                        id: 'outlined-textarea', default: '', rows: 2, type: 'text_area', maxLength: 255
                    },
                    // {
                    //     label: 'Map Location', regex: null, name: 'secondary_map_location', md: 6, className: 'w-95-per', required: true,
                    //     id: 'outlined-textarea', default: '', rows: 2, type: 'text_area', maxLength: 255
                    // },
                    {
                        label: 'Client Billing Status', regex: null, name: 'secondary_client_billing_status', md: 4, className: 'w-90-per', required: false,
                        id: 'outlined-textarea', default: 'GOOD', rows: null, type: 'dropDown',
                        list: [{ id: 'GOOD', name: 'GOOD' }, { id: 'MODERATE', name: 'MODERATE' }, { id: 'CRITICAL', name: 'CRITICAL' }]
                    },
                ],
            }
        }
    }
}
]

export default Form_Details